<template>
  <div class="main print-no-padding">
    <h2 class="is-print-hide title-area">
      <span class="main-title">职员管理</span>
      <div class="handler-area">
        <div class="add-staff btn global_common_button_focus" @click="gopage('staffManagement/addStaff')">
          <span>+ 添加职员</span>
        </div>
      </div>
    </h2>
    <div class="list-content">
      <div class="listSearchArea">
        <search-input @search="search" :searchData="searchData" class="pull-left is-print-hide"></search-input>
      </div>
      <div class="toolbar">
        <el-button @click="exportStaffManagement">
          {{ `导出${staffRes.totalCount > 0 ? `(${staffRes.totalCount})` : ''}` }}
        </el-button>
      </div>
      <staff-table :List="staffRes.data" @selectChange="selectChange"></staff-table>
      <div class="footer">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="pageSizes"
          :page-size.sync="pageSize"
          @size-change="handleSizeChange"
          layout="prev, pager, next, total, jumper,sizes"
          :total="staffRes.totalCount"
          class="is-print-hide common-el-pagination"
        ></el-pagination>
        <div class="sureJump global_common_button_goast">确定</div>
      </div>
    </div>
    <!-- <direction></direction> -->
  </div>
</template>

<script>
import searchInput from './components/searchBar';
import staffTable from './components/table';
import { Button, Pagination } from 'element-ui';
// import direction from '@/components/global/direction';
import Vue from 'vue';
import Constant from '@/lib/constant';
const baseRole = Constant.RoleList;
Vue.use(Button);
Vue.use(Pagination);
let isloadFinish = true; // 限制重复请求
export default {
  name: 'staffManagement',
  data() {
    return {
      selectIds: '',
      currentPage: 1,
      staffRes: {},
      searchData: {
        name: '',
        storeName: '',
        userName: '',
        role: ''
      },
      pageSizes: [12, 24, 36, 48],
      pageSize: 12
    };
  },
  computed: {
    searchParam: function () {
      return {
        name: this.searchData.name,
        storeName: this.searchData.storeName,
        userName: this.searchData.userName,
        role: this.searchData.role
      };
    },
    idsNum() {
      return this.selectIds ? this.selectIds.split(',').length : 0;
    }
  },
  components: {
    searchInput,
    staffTable
    // direction
  },
  created() {
    let params = {
      pageNo: this.currentPage,
      pageSize: Constant.pageSize
    };
    this.fetchList(params);
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 刷新页面或者从详情页面进来默认不刷新数据
      ![null, 'showStaff'].includes(from.name) && vm.initData();
    });
  },
  methods: {
    initData() {
      this.currentPage = 1;
      this.staffRes = {};
      this.searchData = {
        name: '',
        storeName: '',
        userName: ''
      };
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      this.fetchList(params);
    },
    search(data) {
      this.searchData = data;
      this.currentPage = 1;
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        ...this.searchParam
      };
      let self = this;
      Util.submitOnce(function () {
        self.fetchList(params);
      });
    },
    handleCurrentChange(val) {
      let params = {
        pageNo: val,
        pageSize: this.pageSize,
        ...this.searchParam
      };
      this.fetchList(params);
    },
    handleSizeChange(val) {
      let params = {
        pageNo: this.currentPage,
        pageSize: val,
        ...this.searchParam
      };
      this.fetchList(params);
    },
    fetchList(param) {
      if (!isloadFinish) return;
      isloadFinish = false;
      Fetch.getUserPage(param).then(
        res => {
          isloadFinish = true;
          if (res.data && res.data[0]) {
            res.data.forEach(user => {
              if (user.roleList && user.roleList[0]) {
                // 选出公司负责人角色index
                let companyRepresentative = user.roleList.findIndex(item => {
                  return item.code == baseRole.a;
                });
                if (companyRepresentative > -1) {
                  user.companyRepresentative = true;
                } else {
                  user.companyRepresentative = false;
                }
              }
            });
          }
          this.staffRes = res;
        },
        () => {
          isloadFinish = true;
          this.staffRes = {};
        }
      );
    },
    selectChange(ids) {
      this.selectIds = ids;
    },
    gopage(p) {
      // 页面调转
      this.$router.push(p);
    },
    exportStaffManagement() {
      const { storeName, name, userName, role } = this.searchParam;
      if (this.staffRes.totalCount > 0) {
        if (this.staffRes.totalCount > 9999) {
          this.$alert('导出数据量过大会导致导出失败，建议调整导出范围，最多能导出9999条', '数据导出失败', {
            customClass: 'hint',
            center: true,
            confirmButtonText: '重新选择导出范围'
          });
        } else {
          this.$store.dispatch('download/exportFile', {
            exportType: 'export_user_async',
            storeName,
            name,
            userName,
            role
          });
        }
      } else {
        this.$message.error('请选择导出数据');
      }
    }
  }
};
</script>

<style lang="scss">
.tab-pre,
.el-breadcrumb {
  font-size: 12px;
  color: #999999;
  line-height: 40px;
}

.el-table th {
  background: #f7f7f7;
  color: #666;
}
// .el-pagination {
//   // margin-top: 22px;
//   text-align: center;
// }

.el-pagination__total,
.el-pagination__jump {
  color: #999;
}
</style>

<style lang="scss" scoped>
.title-area {
  overflow: hidden;
  padding-bottom: 10px;
  .main-title {
    float: left;
    line-height: 40px;
  }
  .handler-area {
    .setting {
      border: 1px solid #1e8dff;
      span {
        color: #1e8dff;
      }
    }
    .add-staff {
      // background: #ebb436;
      span {
        // color: #fff;
      }
    }
    .btn {
      width: 132px;
      height: 40px;
      float: right;
      line-height: 40px;
      text-align: center;
      margin-right: 16px;
      border-radius: 4px;
      cursor: pointer;
      span {
        font-size: 14px;
      }
    }
  }
  .cancle {
    border: 1px solid #1e8dff;
    span {
      color: #1e8dff;
    }
  }
  .submit {
    background: #1e8dff;
    span {
      color: #fff;
    }
  }
}
.list-content {
  background: #ffffff;
  border: 1px solid #f2f2f2;
  box-shadow: 0 4px 12px 0 #ededed;
  border-radius: 4px;
  padding: 16px;
  .listSearchArea {
    /*padding-bottom: 20px;*/
    &:after {
      content: '.';
      display: block;
      height: 0;
      clear: both;
      visibility: hidden;
    }
    .select_from_store_name {
      float: left;
    }
  }
}
.footer {
  overflow: hidden;
  display: flex;
  justify-content: center;
  .sureJump {
    // float: left;
    width: 80px;
    height: 32px;
    // color: #1E8DFF;
    // background: #ffffff;
    // border: 1px solid #1E8DFF;
    border-radius: 3px;
    text-align: center;
    line-height: 32px;
    cursor: pointer;
    margin-top: 20px;
    margin-left: 10px;
  }
}
.header_fix {
  // min-width: 1100px;
  // &:after {
  //   content: '.';
  //   display: block;
  //   height: 0;
  //   clear: both;
  //   visibility: hidden;
  // }
  // position: relative;

  // .b1,
  // .b2 {
  //   position: absolute;
  //   bottom: 15px;
  // }
  // .b1 {
  //   right: 0;
  // }
  // .b2 {
  //   right: 200px;
  // }
}
.toolbar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 15px;
}
</style>
